export default {
    getIDCurentUser: state => {
      return state.currentUser.id;
    },

    getLoginCurentUser: state => {      
      return state.currentUser.login;
    },

    getScopesCurentUser: state => {      
      //return state.currentUser.scopes;
      return state.currentSession.scopes;
    },
    
    getRoleCurentUser: state => {      
      return state.currentUser.role;
    } ,

    getCurrentPerson: state => state.currentPerson,

    getOwnerPerson: state => state.ownerPerson
}
